import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import Home from '../views/Home.vue'

// роуты
import contracts from './contracts'
import contractors from './contractors'
import users from './users'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  // плагин сотрудников
  ...users,
  // плагин договоров
  ...contracts,
  // плагин контрагенты
  ...contractors
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // если мобильная версия, нужно закрывать меню после перехода
  const isMobile = store.getters.getMediaBreakpoint !== 'desktop'
  if (isMobile) {
    store.commit('CLOSE_MAIN_MENU_MOBILE')
  }
  next()
})

export default router
